module.exports = __webpack_public_path__ + "static/getman-be43c4ce35afb88d66972b22067ee643.png";